/**
 * Clones a node deeply and applies its styles to the clone.
 * @param node The node to clone.
 * @returns The cloned node.
 */
export default function cloneNodeWithStyles<
  NodeType extends HTMLElement | Element | Node,
>(node: NodeType, stylesToApply?: Partial<CSSStyleDeclaration>): NodeType {
  const clone = node.cloneNode(false) as NodeType;

  // get computed styles of the original node
  if (node instanceof HTMLElement) {
    const styles = window.getComputedStyle(node);

    // Apply computed styles to the clone
    for (let i = 0; i < styles.length; i += 1) {
      const prop = styles[i];
      (clone as HTMLElement).style[prop as any] = styles.getPropertyValue(prop);
    }

    if (stylesToApply) {
      for (const key in stylesToApply) {
        if (stylesToApply[key] !== undefined) {
          (clone as HTMLElement).style[key] = stylesToApply[key];
        }
      }
    }
  }

  // append children recursively
  let child = node.firstChild;
  while (child) {
    clone.appendChild(cloneNodeWithStyles(child as HTMLElement, stylesToApply));
    child = child.nextSibling;
  }

  return clone;
}
